import {
  ChevronDown,
  Lightbulb,
  Handshake,
  BriefcaseBusiness,
  Building2,
  FileSpreadsheet,
  Building,
} from "lucide-react";
import { Briefcase } from "lucide-react";

import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";

const OurExpertiseDropdown = ({ isMobile = false, setToggle }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const expertisePaths = [
    "/tax-consulting",
    "/mergers-and-acquisitions",
    "/business-advisory",
    "/real-estate",
  ];

  return (
    <div
      className={` ${
        !isMobile
          ? "relative inline-block"
          : "p-0 m-0  flex flex-col items-start"
      } text-left`}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <button
        className={`p-0 gap-1   items-center navlink-styles transition-all ${
          !isMobile ? "inline-flex relative" : "flex"
        } ${
          expertisePaths.includes(window.location.pathname)
            ? "text-gold font-semibold"
            : "text-white font-medium"
        }`}
      >
        <span className="flex gap-4">
          {isMobile && <Lightbulb size={20} className="navlink-icon" />} Our
          Expertise
        </span>
        <ChevronDown size={15} />
      </button>

      {isMobile ? (
        <div
          className={` mt-2 z-10 right-1 w-auto text-nowrap rounded-md shadow-lg text-white ring-1 ring-black ring-opacity-5 transition-all duration-300 ease-in-out overflow-hidden ${
            isOpen
              ? "opacity-100 scale-100 max-h-96"
              : "opacity-0 scale-95 max-h-0"
          }`}
        >
          <div className="py-3  flex flex-col gap-2 items-start">
            <Link
              to="/mergers-and-acquisitions"
              // onClick={() => setIsOpen(false)}
              onClick={() => {
                setIsOpen(false);
                setToggle(false);
              }}
              className=" font-medium hover:bg-black/10 py-1 rounded-md px-4 text-xs transition-all duration-200 ease-in-out hover:translate-x-1 navlink-styles text-wrap leading-relaxed flex gap-4 items-center navlink-styles2 "
            >
              <Handshake size={27} className="navlink-icon" />
              Mergers & Acquisitions{" "}
            </Link>
            <Link
              to="/business-advisory"
              // onClick={() => setIsOpen(false)}
              onClick={() => {
                setIsOpen(false);
                setToggle(false);
              }}
              className=" font-medium hover:bg-black/10 py-1 rounded-md px-4 text-xs transition-all duration-200 ease-in-out hover:translate-x-1 navlink-styles text-wrap leading-relaxed flex gap-4 items-center navlink-styles2 "
            >
              <BriefcaseBusiness size={20} className="navlink-icon" />
              Business Advisory
            </Link>
            <Link
              to="/real-estate"
              // onClick={() => setIsOpen(false)}
              onClick={() => {
                setIsOpen(false);
                setToggle(false);
              }}
              className=" font-medium hover:bg-black/10 py-1 rounded-md px-4 text-xs transition-all duration-200 ease-in-out hover:translate-x-1 navlink-styles flex gap-4 items-center navlink-styles2"
            >
              <Building2 size={20} className="navlink-icon" />
              Real Estate
            </Link>
            <Link
              to="/tax-consulting"
              // onClick={() => setIsOpen(false)}
              onClick={() => {
                setIsOpen(false);
                setToggle(false);
              }}
              className=" font-medium hover:bg-black/10 py-1 rounded-md px-4 text-xs transition-all duration-200 ease-in-out hover:translate-x-1 navlink-styles flex gap-4 items-center navlink-styles2"
            >
              <FileSpreadsheet size={20} className="navlink-icon" />
              Tax Consulting{" "}
            </Link>
          </div>
        </div>
      ) : (
        <div
          className={`absolute mt-2 z-10 right-1 w-auto text-nowrap rounded-md shadow-lg border border-slate-600 bg-slate-300 text-slate-900 ring-1 ring-black ring-opacity-5 transition-all duration-300 ease-in-out overflow-hidden ${
            isOpen
              ? "opacity-100 scale-100 max-h-96"
              : "opacity-0 scale-95 max-h-0"
          }`}
        >
          <div className="py-3 px-4 flex flex-col gap-2">
            <Link
              to="/mergers-and-acquisitions"
              // onClick={() => setIsOpen(false)}
              onClick={() => {
                setIsOpen(false);
                setToggle(false);
              }}
              className="text-slate-900 font-medium hover:bg-black/10 py-1 rounded-md px-4 text-base transition-all duration-200 ease-in-out hover:translate-x-1 "
            >
              Mergers & Acquisitions
            </Link>
            <Link
              to="/business-advisory"
              // onClick={() => setIsOpen(false)}
              onClick={() => {
                setIsOpen(false);
                setToggle(false);
              }}
              className="text-slate-900 font-medium hover:bg-black/10 py-1 rounded-md px-4 text-base transition-all duration-200 ease-in-out hover:translate-x-1"
            >
              Business Advisory
            </Link>
            <Link
              to="/real-estate"
              // onClick={() => setIsOpen(false)}
              onClick={() => {
                setIsOpen(false);
                setToggle(false);
              }}
              className="text-slate-900 font-medium hover:bg-black/10 py-1 rounded-md px-4 text-base transition-all duration-200 ease-in-out hover:translate-x-1"
            >
              Real Estate
            </Link>
            <Link
              to="/tax-consulting"
              // onClick={() => setIsOpen(false)}
              onClick={() => {
                setIsOpen(false);
                setToggle(false);
              }}
              className="text-slate-900 font-medium hover:bg-black/10 py-1 rounded-md px-4 text-base transition-all duration-200 ease-in-out hover:translate-x-1 "
            >
              Tax Consulting
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default OurExpertiseDropdown;
